import * as React from 'react';
import { Button, Checkbox, CircularProgress, FormControlLabel, Grid, Typography } from '@mui/material';

import { AddressInput } from 'components';
import { IAddress } from 'models';

import { useBillingAddressFormManager } from './billing-address-form.hook';

interface BillingAddressFormProps {
  onLoading?: (loading: boolean) => void;
  next?: (data?: any) => void;
}

export const BillingAddressForm = React.forwardRef(({ onLoading = () => {}, next }: BillingAddressFormProps, ref) => {
  const [formManager, { isLoading }] = useBillingAddressFormManager({ next });

  React.useImperativeHandle(ref, () => ({ onSubmit: () => formManager.handleSubmit() }), []);

  React.useEffect(() => onLoading(isLoading), [isLoading]);

  return (
    <form onSubmit={formManager.handleSubmit}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <AddressInput
            data={{
              id: -1,
              address_1: formManager.values.billing_address1,
              address_2: formManager.values.billing_address2,
              city: formManager.values.billing_city,
              state: formManager.values.billing_state,
              zip: formManager.values.billing_zip,
            }}
            errors={{
              address_1: formManager.touched.billing_address1 ? formManager.errors.billing_address1 || '' : '',
              address_2: formManager.touched.billing_address2 ? formManager.errors.billing_address2 || '' : '',
              city: formManager.touched.billing_city ? formManager.errors.billing_city || '' : '',
              state: formManager.touched.billing_state ? formManager.errors.billing_state || '' : '',
              zip: formManager.touched.billing_zip ? formManager.errors.billing_zip || '' : '',
            }}
            onChangeData={(data: IAddress) => {
              const { address_1, address_2, city, state, zip } = data;

              formManager.setValues({
                ...formManager.values,
                billing_address1: address_1 as string,
                billing_address2: address_2 as string,
                billing_city: city as string,
                billing_state: state as string,
                billing_zip: zip as string,
              });
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={formManager.values.use_billing}
                onChange={(_, checked) => {
                  formManager.setFieldValue('use_billing', checked);
                }}
              />
            }
            label={
              <Typography variant="body2" color="textPrimary">
                My Billing and Shipping Address are the same.
              </Typography>
            }
          />
        </Grid>

        <Grid item xs={12} hidden>
          <Button
            variant="contained"
            type="submit"
            onClick={() => formManager.handleSubmit()}
            endIcon={
              isLoading ? (
                <CircularProgress
                  color="inherit"
                  size={14}
                  sx={{
                    marginLeft: 0.5,
                  }}
                />
              ) : null
            }
            sx={{
              paddingX: 2.5,
            }}
          >
            Update Billing Address
          </Button>
        </Grid>
      </Grid>
    </form>
  );
});
